var Catalogue, Model, config, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = require('models/base/model');

config = require('config');

module.exports = Catalogue = (function(_super) {
  __extends(Catalogue, _super);

  function Catalogue() {
    _ref = Catalogue.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Catalogue.prototype.url = function() {
    return "catalogue.php?catalog=" + (this.get('id'));
  };

  Catalogue.prototype.searchUrl = "catalogue_functions/search_json.php";

  Catalogue.prototype.initialize = function() {
    Catalogue.__super__.initialize.apply(this, arguments);
    this.subscribeEvent('catalogue:searchByKeyWord', this.searchOnServer);
    return this.listenTo(this, 'sync', this.catalogueSynced);
  };

  Catalogue.prototype.parse = function(response) {
    response.products.description = response.descriptions;
    response = response.products;
    response.config = $.extend({}, config);
    console.log(response);
    this.modifyImageSizes(response);
    return response;
  };

  Catalogue.prototype.modifyImageSizes = function(response) {
    var HEADER_HEIGHT, bodyHeight, bodyWidth, normalSize, originalAspectRatio;
    HEADER_HEIGHT = 110;
    normalSize = response.image_sizes.normal;
    response.image_sizes.original_normal = $.extend(true, {}, normalSize);
    originalAspectRatio = normalSize.width * 2 / normalSize.height;
    bodyWidth = $(window).width();
    bodyHeight = $(window).height() - HEADER_HEIGHT;
    if (bodyHeight * originalAspectRatio < bodyWidth) {
      response.image_sizes.normal = {
        width: (bodyHeight * originalAspectRatio) / 2,
        height: bodyHeight
      };
    } else {
      response.image_sizes.normal = {
        width: bodyWidth / 2,
        height: bodyWidth / originalAspectRatio
      };
    }
    response.image_sizes.scaleFactor = response.image_sizes.normal.width / response.image_sizes.original_normal.width;
    return response.image_sizes.actualSize = response.image_sizes.original_normal.width >= response.image_sizes.normal.width ? 'normal' : 'zoom';
  };

  Catalogue.prototype.search = function(keyWord) {
    var searchResults,
      _this = this;
    searchResults = [];
    _(this.get('pages').page).each(function(page) {
      if (_this.testStingOnKey(page.title, keyWord)) {
        searchResults.push({
          page: page.number,
          text: page.title
        });
      }
      if (page.hotspots) {
        return _(page.hotspots.hotspot).each(function(hotspot) {
          if (_this.testStingOnKey(hotspot.title, keyWord)) {
            searchResults.push({
              page: page.number,
              text: hotspot.title
            });
          }
          if (_this.testStingOnKey(hotspot.alt_tag, keyWord)) {
            return searchResults.push({
              page: page.number,
              text: hotspot.alt_tag
            });
          }
        });
      }
    });
    return searchResults;
  };

  Catalogue.prototype.testStingOnKey = function(string, key) {
    if (string == null) {
      string = '';
    }
    if (key == null) {
      key = null;
    }
    return (string.toLowerCase().indexOf(key.toLowerCase())) !== -1;
  };

  Catalogue.prototype.searchOnServer = function(keyWord) {
    var result, searchString,
      _this = this;
    this.publishEvent('catalogue:search:start');
    searchString = "catalogue_id=" + (this.get('id')) + "&search=" + keyWord;
    result = $.ajax({
      dataType: 'json',
      type: 'post',
      url: this.searchUrl,
      data: searchString
    });
    return result.done(function(response) {
      if (!response.length) {
        response = [];
      }
      response = {
        success: true,
        hit: response
      };
      return _this.publishEvent('catalogue:search:complete', response);
    });
  };

  Catalogue.prototype.catalogueSynced = function() {
    return this.publishEvent('catalogue:loaded', this);
  };

  Catalogue.prototype.getPagesOffset = function() {
    var index;
    index = _(this.get('pages')).findIndex({
      title: 'Page 1'
    });
    if (index !== -1) {
      return index;
    } else {
      return 0;
    }
  };

  return Catalogue;

})(Model);
